var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bind-root", style: _vm.cssVars }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.RENDER,
            expression: "RENDER"
          }
        ],
        staticClass: "bind-box-sty"
      },
      [
        _c("img", {
          attrs: {
            src: _vm.bindForm.icon || "/images/icon/sign-1.png",
            alt: "电子签约"
          }
        }),
        _c("h1", [_vm._v(_vm._s(_vm.bindForm.platformName || ""))]),
        _c(
          "el-form",
          {
            ref: "bindFormRef",
            staticStyle: { width: "30vw" },
            attrs: {
              "label-width": "100px",
              model: _vm.bindForm,
              rules: _vm.bindRules
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "账号：", prop: "emailOrPhone" } },
              [
                _c("el-input", {
                  attrs: { disabled: _vm.accountBind },
                  model: {
                    value: _vm.bindForm.emailOrPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.bindForm, "emailOrPhone", $$v)
                    },
                    expression: "bindForm.emailOrPhone"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "验证码：", prop: "valicode" } },
              [
                _c(
                  "el-input",
                  {
                    model: {
                      value: _vm.bindForm.valicode,
                      callback: function($$v) {
                        _vm.$set(_vm.bindForm, "valicode", $$v)
                      },
                      expression: "bindForm.valicode"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        style: {
                          "background-color": _vm.bindForm.btnColor,
                          "border-color": _vm.bindForm.btnColor
                        },
                        attrs: { slot: "append", disabled: _vm.countdown > 0 },
                        on: { click: _vm.verifyHandle },
                        slot: "append"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.countdown > 0
                              ? _vm.countdown + " S"
                              : "获取验证码"
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticStyle: { "text-align": "center" } },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "comfirm-btn",
                    attrs: { round: "" },
                    on: {
                      click: function($event) {
                        return _vm.submitForm("bindForm")
                      }
                    }
                  },
                  [_vm._v("确认授权")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ]
      },
      [
        _c(
          "AliCaptcha",
          {
            attrs: {
              handCallback: _vm.countdownLe,
              targetId: _vm.bindForm.emailOrPhone,
              verifyType: _vm.BUSITYPE.ACCOUNTBIND
            }
          },
          [_c("button", { ref: "aliCaptchaRef" }, [_vm._v("发送验证码")])]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-463a8465", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-463a8465","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/binding/bind.vue
// module id = nj9j
// module chunks = 175